const restrictions = {
    none: ['user', 'author', 'editor', 'admin'],
    author: ['author', 'editor', 'admin'], 
    editor: ['editor', 'admin'],
    admin: ['admin'],
};

export default restrictions;
